import { ReactNode } from 'react'

interface ISectionCardProps {
  title: string
  children: ReactNode
}

export const SectionCard = ({ title, children }: ISectionCardProps) => (
  <div className={'flex flex-col gap-[16px] rounded-[16px] bg-[#F7FAFD] p-[16px]'}>
    <h4 className={'text-[18px] font-semibold'}>{title}</h4>
    {children}
  </div>
)
